export default __webpack_public_path__ + "static/media/file-upload.1f8ccc1e.svg";